import axios from 'axios'

export default {
  async getOneBySlug({ slug, isOnlyHighQuality, limit }) {
    return axios.get(`/topics/${slug}`, {
      params: { isOnlyHighQuality, limit }
    })
  }
}
